var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:[_vm.$globalConfig.APP_NAME == 'senso' ? 'edify' : 'improve'],attrs:{"id":"improve"}},[_c('cookie-banner'),_c('router-view'),(_vm.$store.getters.isLoggedIn)?_c('webinar-booking-dialog'):_vm._e(),_c('vue-snotify')],1)}
var staticRenderFns = []

export { render, staticRenderFns }